import axiosInstance from './Instance/axiosInstance';
import { ReturnInvoice } from '../types/return';

export const getReturns = async (): Promise<ReturnInvoice[]> => {
    const res = await axiosInstance.get('/returns');
    return res.data;
};

export const createReturn = async (data: Omit<ReturnInvoice, 'id'>): Promise<ReturnInvoice> => {
    const res = await axiosInstance.post('/returns', data);
    return res.data;
};

export const updateReturn = async (id: string, data: Omit<ReturnInvoice, 'id'>): Promise<ReturnInvoice> => {
    const res = await axiosInstance.put(`/returns/${id}`, data);
    return res.data;
};

export const deleteReturn = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/returns/${id}`);
};

export const getReturn = async (id: string): Promise<ReturnInvoice> => {
    const doc = await axiosInstance.get(`/returns/${id}`);
    return doc.data;
};